/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Ad_Pitch_LabelInputs */



/**
* | output |
* | --- |
* | "Pitch" |
*
* @param {Event_Ad_Pitch_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_ad_pitch_label = /** @type {((inputs?: Event_Ad_Pitch_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Ad_Pitch_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pas")
	if (locale === "de") return /** @type {LocalizedString} */ ("Tonhöhe")
	if (locale === "it") return /** @type {LocalizedString} */ ("Pece")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Подача")
	if (locale === "es") return /** @type {LocalizedString} */ ("Paso")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("沥青")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ピッチ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आवाज़ का उतार-चढ़ाव")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tom")
	return /** @type {LocalizedString} */ ("Pitch")
});